import type { SelectChangeEvent } from '@all-manager/design-system-v2';
import { useRouterLinkClick } from '../../../../hooks/useRouterLinkClick';
import type { StatusFilter, TopicListPage } from '../../pages/useTopicListPage';

export function useSubTopicListPanel(page: TopicListPage) {
  const handleBackClick = useRouterLinkClick(page.listHref);

  function handleNewSubTopicClick() {
    page.setIsNewSubTopicModalOpen(true);
  }

  function handleStatusFilterChange(event: SelectChangeEvent<StatusFilter>) {
    page.setSubStatusFilter(event.target.value as StatusFilter);
  }

  return {
    handleBackClick,
    handleNewSubTopicClick,
    handleStatusFilterChange,
    isEmpty: page.subTopics.length === 0,
    noResultSubtitle: page.subSearch.trim()
      ? `Aucun sous-sujet ne correspond à « ${page.subSearch.trim()} ».`
      : 'Aucun sous-sujet ne correspond à ce statut.',
  };
}
